import { BarChart3, TrendingUp } from "lucide-react";

function StatisticValue({ statisticvalues }) {
  // console.log(statisticvalues);

  if (!statisticvalues || !Array.isArray(statisticvalues)) {
    return null;
  }

  // En çok tekrar edilen değeri bul
  const maxCount = Math.max(...statisticvalues.map((item) => item.count));

  // Tekrar sayısına göre renk belirle
  const getColorClasses = (count) => {
    if (count <= 1) {
      return {
        gradient: "from-green-500 to-green-600",
        bg: "bg-green-50",
        text: "text-green-600",
        border: "border-green-200",
      };
    } else if (count <= 5) {
      return {
        gradient: "from-yellow-500 to-yellow-600",
        bg: "bg-yellow-50",
        text: "text-yellow-600",
        border: "border-yellow-200",
      };
    } else {
      return {
        gradient: "from-red-500 to-red-600",
        bg: "bg-red-50",
        text: "text-red-600",
        border: "border-red-200",
      };
    }
  };

  return (
    <div className="space-y-3 mb-6">
      <div className="flex items-center gap-2 mb-4">
        <BarChart3 className="w-5 h-5 text-blue-600" />
        <h4 className="text-sm font-semibold text-gray-700">
          Öğrenme İstatistikleri
        </h4>
      </div>

      <div className="space-y-2">
        {statisticvalues.map((item, index) => {
          const percentage = (item.count / maxCount) * 100;
          const colors = getColorClasses(item.count);

          return (
            <div
              key={index}
              className={`bg-gradient-to-r from-gray-50 to-white rounded-lg p-3 border ${colors.border} hover:shadow-md transition-all duration-200`}
            >
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-800">
                  {item.value}
                </span>
                <span
                  className={`flex items-center gap-1 text-xs font-semibold ${colors.text} ${colors.bg} px-2 py-1 rounded-full`}
                >
                  <TrendingUp className="w-3 h-3" />
                  {item.count} tekrar
                </span>
              </div>

              {/* Progress bar */}
              <div className="w-full bg-red-200 rounded-full h-2 overflow-hidden">
                <div
                  className={`bg-gradient-to-r ${colors.gradient} h-2 rounded-full transition-all duration-500`}
                  style={{ width: `${percentage}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default StatisticValue;
